import { Tag } from "antd";

const ESTADOS = {
  PENDIENTE_CARGA: { color: "orange", texto: "Pendiente de carga" },
  ACTA_CARGADA: { color: "green", texto: "Acta cargada" },
};

export default function EstadoManifestacion({ estado, eliminada }) {
  if (eliminada) return <Tag color="red">Eliminada</Tag>;
  const { color, texto } = ESTADOS[estado] || { color: "default", texto: estado };
  return <Tag color={color}>{texto}</Tag>;
}
